<template>
    <div v-if="isVisible" class="vehicle-loading-live-map-legend">
        <ProgressSpinner
            style="width: 20px; height: 20px"
            strokeWidth="4"
            fill="#212121"
            animationDuration=".5s"
            aria-label="Loading live vehicle positions"
        />
        <span class="vehicle-loading-live-map-legend__text">{{ loadingText }}</span>
    </div>
</template>

<script>
import { useVehiclesLiveStore } from '@/stores/vehiclesLive'

export default {
    name: 'VehicleLoadingLiveMapLegend',
    setup() {
        const vLive = useVehiclesLiveStore()

        return { vLive }
    },
    computed: {
        isVisible() {
            return this.vLive.liveOnFieldsMap && this.vLive.fieldsMapLiveLoading
        },
        loadingText() {
            const key = this.vLive.vehicleSerials.length === 1
                ? 'Loading live vehicle position...'
                : 'Loading live vehicle positions...'

            return this.$t(key)
        },
    },
}
</script>

<style scoped>
.vehicle-loading-live-map-legend {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: #212121;
    color: #fff;
    min-width: 220px;
    max-width: 320px;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #313131;
}

.vehicle-loading-live-map-legend__text {
    font-size: 13px;
    color: #ebebeb;
}
</style>
